<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-9"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <table
                                v-if="status.list"
                                class="table table-centered table-nowrap"
                            >
                                <thead>
                                    <tr>
                                        <th class="text-nowrap">#</th>
                                        <th class="text-nowrap">{{ $t('label.name') }}</th>
                                        <th class="text-nowrap">{{ $t('label.description') }}</th>
                                        <th class="text-nowrap">Operational</th>
                                        <th class="text-nowrap">{{ $t('label.status') }}</th>
                                        <th class="text-nowrap">{{ $t('label.action') }}</th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="propertyStatusList"
                                    tag="tbody"
                                    ghost-class="drag-ghost"
                                    chosen-class="drag-chosen"
                                    drag-class="drag-active"
                                    :animation="300"
                                    easing="cubic-bezier(0.25, 1, 0.5, 1)"
                                    :disabled="!status.save"
                                    handle=".draggable-item-handle"
                                    @change="requestUpdateSequence"
                                >
                                    <tr
                                        v-for="(item, index) in propertyStatusList"
                                        :key="index"
                                    >
                                        <td class="text-nowrap">
                                            <i class="mdi mdi-menu-swap font-size-18 cursor-pointer draggable-item-handle"></i>
                                            {{ index + 1 }}
                                        </td>
                                        <td class="text-nowrap">{{ item.name }}</td>
                                        <td class="text-nowrap">{{ item.description ? item.description : '--' }}</td>
                                        <td class="text-nowrap">
                                            <i :class="item.isOperational ? 'text-info mdi mdi-checkbox-marked-circle' : 'text-muted mdi mdi-close-circle'"></i>
                                        </td>
                                        <td class="text-nowrap">
                                            <b-badge
                                                :variant="item.isActive ? 'success' : 'secondary'"
                                            >
                                                {{ item.isActive ? $t('label.active') : $t('label.inactive') }}
                                            </b-badge>
                                        </td>
                                        <td class="text-nowrap">
                                            <a
                                                href="javascript:void(0);"
                                                class="text-info"
                                                v-b-tooltip.hover
                                                :title="$t('label.updateX', [])"
                                                @click.stop="openForm(item)"
                                            >
                                                <i class="mdi mdi-pencil font-size-18"></i>
                                            </a>
                                            <a
                                                href="javascript:void(0);"
                                                class="text-info ml-1"
                                                v-b-tooltip.hover
                                                :title="item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                                v-on:click="deleteConfirmation(item)"
                                            >
                                                <i :class="[`mdi font-size-18 mdi-delete-${item.isActive==0?'restore':'outline'}`]"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="property-status-form"
            :title="$t(propertyStatus.uuid ? 'label.updateX' : 'label.createX', [$t('module.propertyStatus')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <PropertyStatusForm
                    :propertyStatusUUID="propertyStatus.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="propertyStatusForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="property-status-delete"
            :title="propertyStatus.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ propertyStatus.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('property-status-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ propertyStatus.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import { SESSION } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { propertyStatusMethods } from "@/state/api";
import { PROPERTY_STATUS_MODULE } from "@/state/api/propertyStatus.state";
import PropertyStatusForm from "@/views/pages/admin/propertyStatus/propertyStatusForm";

export default {
    components: { Multiselect, draggable, PropertyStatusForm },
    created() {
        sessionHelper.clearSearch(SESSION.PROPERTY_STATUS_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            propertyStatusList: [],
            propertyStatus: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...propertyStatusMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.PROPERTY_STATUS_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PROPERTY_STATUS_SEARCH);
            }
            if(isDefault) {
                this.searchCriteria = {
                    isActive: this.isActive.value,
                };
            }
            this.getPropertyStatusList(this.searchCriteria);
        },
        getPropertyStatusList(filter) {
            this.getAllPropertyStatus({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PROPERTY_STATUS_SEARCH, filter);
        },
        searchListing() {
            this.searchCriteria.searchArray = [];
            this.searchCriteria.isActive = this.isActive.value;
            this.getPropertyStatusList(this.searchCriteria);
        },
        requestUpdateSequence() {
            let data = {
                uuids: this.propertyStatusList.map((item) => item.uuid),
            };
            this.updatePropertyStatusSequence({data, filter: this.searchCriteria});
        },
        deleteConfirmation(data) {
            this.propertyStatus = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('property-status-delete');
        },
        requestDelete() {
			let data = {
                uuid: this.propertyStatus.uuid,
				isActive: this.propertyStatus.isActive == 0 ? 1 : 0,
			};
            this.updatePropertyStatusStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('property-status-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.propertyStatus = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('property-status-form');
            });
        },
        closeForm() {
            this.propertyStatus = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('property-status-form');
        },
    },
	computed: {
		...mapState(PROPERTY_STATUS_MODULE, ['status']),
		tableRows() {
			return this.$store.state.api.propertyStatus.list.data || [];
		},
		totalPage() {
			return this.$store.state.api.propertyStatus.list.pagination.total || 0;
		},
	},
    watch: {
        tableRows: {
            immediate: true,
            handler(value) {
                this.propertyStatusList = [...value].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
            },
        },
    },
}
</script>
<style>
.drag-ghost {
    opacity: 0.3;
    background: #e9ecef !important;
}

.drag-chosen {
    background: #f8f9fa !important;
}

.drag-active {
    background: #ffffff !important;
    box-shadow: 0 4px 12px rgba(0,0,0,.15);
}
</style>
